import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Skills from './pages/Skills'
import SkillDetail from './pages/SkillDetail'
import Forum from './pages/Forum'
import PostDetail from './pages/PostDetail'
import NewPost from './pages/NewPost'
import Login from './pages/Login'
import Profile from './pages/Profile'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Contact from './pages/Contact'
import AdminLogin from './pages/AdminLogin'
import Admin from './pages/Admin'
import AdminGuard from './components/AdminGuard'
import NotFound from './pages/NotFound'
import TestPayment from './pages/TestPayment'
import TestOceanPay from './pages/TestOceanPay'
import Membership from './pages/Membership'
import Subscription from './pages/Subscription'
import Guide from './pages/Guide'
import TestHzbankPay from './pages/TestHzbankPay'
import Test360Pay from './pages/Test360Pay'
import TestReminderFlow from './pages/TestReminderFlow'
import OpenClawOfficial from './pages/OpenClawOfficial'
import OpenClawInstall from './pages/OpenClawInstall'
import OpenClawWhatIs from './pages/OpenClawWhatIs'
import OpenClawLocalDeploy from './pages/OpenClawLocalDeploy'
import OpenClawAd360Display from './pages/OpenClawAd360Display'
import OpenClawAdSohuDisplay from './pages/OpenClawAdSohuDisplay'
import OpenClawAdIqiyiDisplay from './pages/OpenClawAdIqiyiDisplay'
import OpenClawAdBilibiliDisplay from './pages/OpenClawAdBilibiliDisplay'
import OpenClawAdBaiduDisplay from './pages/OpenClawAdBaiduDisplay'
import OpenClawAd2345Display from './pages/OpenClawAd2345Display'
import OpenClawAdTencentDisplay from './pages/OpenClawAdTencentDisplay'
import OpenClawBingDisplay from './pages/OpenClawBingDisplay'
import OpenClawBing2Display from './pages/OpenClawBing2Display'
import CustomerServiceFloat from './components/CustomerServiceFloat'

function App() {
  const isAd360OnlySite = import.meta.env.VITE_SITE_MODE === 'ad360_only'
  const isAdBaiduOnlySite = import.meta.env.VITE_SITE_MODE === 'adbaidu_only'

  if (isAd360OnlySite) {
    return (
      <>
        <Routes>
          <Route path="/ad360" element={<OpenClawAd360Display />} />
          <Route path="/adbilibili/luqi" element={<OpenClawAdBilibiliDisplay />} />
          <Route path="/adbilibili/luqi2" element={<OpenClawAdBilibiliDisplay />} />
          <Route path="/adbilibili/snk" element={<OpenClawAdBilibiliDisplay />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CustomerServiceFloat />
      </>
    )
  }

  if (isAdBaiduOnlySite) {
    return (
      <>
        <Routes>
          <Route path="/" element={<OpenClawAdBaiduDisplay />} />
          <Route path="/adbaidu" element={<OpenClawAdBaiduDisplay />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CustomerServiceFloat />
      </>
    )
  }

  return (
    <>
      <Routes>
        <Route path="/official" element={<OpenClawOfficial />} />
        <Route path="/install" element={<OpenClawInstall />} />
        <Route path="/what-is" element={<OpenClawWhatIs />} />
        <Route path="/local-deploy" element={<OpenClawLocalDeploy />} />
        <Route path="/local-deploy2" element={<OpenClawLocalDeploy landingPage="local-deploy2" />} />
        <Route path="/ad360" element={<OpenClawAd360Display />} />
        <Route path="/adsohu" element={<OpenClawAdSohuDisplay />} />
        <Route path="/adiqiyi" element={<OpenClawAdIqiyiDisplay />} />
        <Route path="/adiqiyi2" element={<OpenClawAdIqiyiDisplay />} />
        <Route path="/adbilibili/luqi" element={<OpenClawAdBilibiliDisplay />} />
        <Route path="/adbilibili/luqi2" element={<OpenClawAdBilibiliDisplay />} />
        <Route path="/adbilibili/snk" element={<OpenClawAdBilibiliDisplay />} />
        <Route path="/ad2345" element={<OpenClawAd2345Display />} />
        <Route path="/adtencent" element={<OpenClawAdTencentDisplay />} />
        {Array.from({ length: 50 }, (_, i) => (
          <Route key={`adtencent-${i + 1}`} path={`/adtencent-${i + 1}`} element={<OpenClawAdTencentDisplay />} />
        ))}
        {Array.from({ length: 400 }, (_, i) => (
          <Route key={`adtencent-${i + 101}`} path={`/adtencent-${i + 101}`} element={<OpenClawAdTencentDisplay />} />
        ))}
        <Route path="/adtentent" element={<OpenClawAdTencentDisplay />} />
        <Route path="/bing" element={<OpenClawBingDisplay />} />
        <Route path="/bing2" element={<OpenClawBing2Display />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="global" element={<Home downloadIds={['windows-global']} />} />
          <Route path="skills" element={<Skills />} />
          <Route path="skills/:id" element={<SkillDetail />} />
          <Route path="forum" element={<Forum />} />
          <Route path="forum/post/:id" element={<PostDetail />} />
          <Route path="forum/new" element={<NewPost />} />
          <Route path="login" element={<Login />} />
          <Route path="profile" element={<Profile />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="contact" element={<Contact />} />
          <Route path="test-payment" element={<TestPayment />} />
          <Route path="test-oceanpay" element={<TestOceanPay />} />
          <Route path="test-hzbank-pay" element={<TestHzbankPay />} />
          <Route path="test-360-pay" element={<Test360Pay />} />
          <Route path="test-reminder-flow" element={<TestReminderFlow />} />
          <Route path="membership" element={<Membership />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="guide/*" element={<Guide />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* Admin Routes - No Layout (受环境变量控制) */}
        {import.meta.env.VITE_DISABLE_ADMIN !== 'true' && (
          <>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard><Admin /></AdminGuard>} />
          </>
        )}
      </Routes>
      {/* 官网右侧客服入口临时隐藏（恢复时取消注释即可） */}
      {/* <CustomerServiceFloat /> */}
    </>
  )
}

export default App
